export default __webpack_public_path__ + "static/media/undraw_team_collaboration_re_ow29.ec3066a9.svg";